/**
 * "로그인 유지" 를 켠 적이 있는가. 화면 문구를 고르는 데만 쓴다.
 *
 * 🔴 이것은 자격증명이 아니다. 아무 권한도 주지 않는다
 *   값이 true 라고 해서 로그인되는 것이 아니다. 실제 인증은 세션 쿠키가 하고,
 *   그 쿠키는 HttpOnly 라 JS 가 읽지 못한다 — 그것이 맞는 설계다.
 *   누가 이 값을 개발자도구로 true 로 바꿔도 얻는 것은 스피너 문구뿐이다.
 *
 * 왜 필요한가
 *   앱을 열면 /api/auth/me 응답이 올 때까지 잠깐 기다린다.
 *   그동안 화면에 무엇이라고 쓸지가 두 갈래다.
 *
 *     로그인 유지를 켠 사람    "로그인 중입니다"   곧 들어갈 것이다
 *     그렇지 않은 사람         "확인 중"          곧 로그인 화면으로 갈 것이다
 *
 *   쿠키를 읽을 수 없으니 어느 쪽인지 서버 응답 전에는 알 수 없다.
 *   그래서 로그인할 때 켰다는 사실만 따로 적어둔다.
 *
 *   전부 "로그인 중입니다" 로 쓰면, 로그인한 적 없는 사람에게도
 *   그 문구가 스쳤다가 로그인 화면이 뜬다. 거짓말이다.
 */

/** theme·font 와 같은 성격의 로컬 설정이다. 서버는 알 필요가 없다. */
export const AUTO_LOGIN_STORAGE_KEY = 'autoLogin';

/** 로그인 유지를 켠 적이 있는가. */
export function hasAutoLoginHint(): boolean {
  try {
    return localStorage.getItem(AUTO_LOGIN_STORAGE_KEY) === '1';
  } catch {
    // 사파리 프라이빗 모드 등에서 localStorage 가 막힐 수 있다.
    // 문구가 조금 덜 친절해질 뿐이라 조용히 넘어간다. (theme.ts 와 같은 처리)
    return false;
  }
}

/**
 * 로그인 성공 시 호출한다.
 *
 * 로그인 유지를 끄고 로그인했다면 표시도 지운다.
 * 남겨두면 다음에 브라우저를 열었을 때 "로그인 중입니다" 가 떴다가
 * 로그인 화면으로 떨어진다.
 */
export function rememberAutoLogin(rememberMe: boolean): void {
  try {
    if (rememberMe) {
      localStorage.setItem(AUTO_LOGIN_STORAGE_KEY, '1');
    } else {
      localStorage.removeItem(AUTO_LOGIN_STORAGE_KEY);
    }
  } catch {
    /* 위와 같은 이유로 삼킨다 */
  }
}

/**
 * 로그아웃 시 호출한다.
 *
 * 🔴 이것이 없으면 사용자가 직접 로그아웃했는데도 다음 방문에
 *   "로그인 중입니다" 가 뜬다. 나가겠다는 의사를 화면이 무시하는 셈이다.
 */
export function forgetAutoLogin(): void {
  try {
    localStorage.removeItem(AUTO_LOGIN_STORAGE_KEY);
  } catch {
    /* 같음 */
  }
}
